/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC721, ERC721Interface } from "../ERC721";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ERC721__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    name_: string,
    symbol_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721> {
    return super.deploy(name_, symbol_, overrides || {}) as Promise<ERC721>;
  }
  getDeployTransaction(
    name_: string,
    symbol_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(name_, symbol_, overrides || {});
  }
  attach(address: string): ERC721 {
    return super.attach(address) as ERC721;
  }
  connect(signer: Signer): ERC721__factory {
    return super.connect(signer) as ERC721__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721Interface {
    return new utils.Interface(_abi) as ERC721Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ERC721 {
    return new Contract(address, _abi, signerOrProvider) as ERC721;
  }
}
